<template>
    <el-tooltip content="发送表情" placement="top" effect="light">
        <el-popover
         placement="bottom"
         width="330"
         v-model="visible">
            <ul class="emoji_list">
                <li
                v-for="(item, index) in emojiList"
                :key="index">
                    <img :src="item.img" @click="handlerEmoji(index)" alt=""> 
                </li>
            </ul>
            <img class="common_emoji" slot="reference" src="@/assets/tic/emoji.png" alt="">
        </el-popover>
    </el-tooltip>
</template>
<script>
import emoji from './emoji';
export default {
    props: ["sendEmojiMessage", 'enableChat'],
    data() {
        return {
            emojiList: emoji,
            visible: false
        }
    },
    methods: {
        handlerEmoji(index) {
            if(this.enableChat) {
                this.$emit("sendEmojiMessage", index);
                this.visible = false; 
            }
        },
    }
}
</script>
<style scoped>
.emoji_list {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 300px;
    margin: 0;
    padding: 0;
    overflow-x: scroll;
}
.emoji_list::-webkit-scrollbar {
    width: 3px;
}
.emoji_list::-webkit-scrollbar-thumb {
    width: 8px;
    height: 20px;
    background: #999aaa;
    border-radius: 3px;
}
.emoji_list li {
    width: 50px;
    height: 50px;
    padding: 10px;
}
.emoji_list li img {
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.common_emoji {
    /* position: absolute;
    top: 3px;
    left: 3px; */
    width: 28px;
    height: 28px;
    cursor: pointer;
    /* z-index: 1; */
}
</style>


// WEBPACK FOOTER //
// src/views/classroom1/components/emoji.vue